import { ref, reactive, computed, watch, onBeforeUnmount, onMounted } from 'vue';

const useStoreModule = (storeOptions, componentInputs, emits, configuration) => {
  var _a;
  const { storeModule } = storeOptions;
  const isLoadingStoreData = ref(true);
  const storeResponse = reactive({ data: void 0, meta: void 0 });
  const storeErrorsBag = ref([]);
  const hasStoreErrors = computed(() => storeErrorsBag.value.length > 0);
  const requestDataOnComponentInputsChange = (_a = configuration == null ? void 0 : configuration.requestDataOnComponentInputsChange) != null ? _a : true;
  const storeRequestData = async () => {
    isLoadingStoreData.value = true;
    let response;
    try {
      response = await (storeModule == null ? void 0 : storeModule.updateComponentsInputs(componentInputs.value));
      storeErrorsBag.value = [];
    } catch (e) {
      storeErrorsBag.value.push(e);
      emits("store-error", storeErrorsBag.value);
    } finally {
      isLoadingStoreData.value = false;
      emits("data-load");
    }
    return response;
  };
  const storeCleanUp = async (oldComponentInputs) => {
    await (storeModule == null ? void 0 : storeModule.cleanUp(oldComponentInputs));
  };
  watch([() => storeModule == null ? void 0 : storeModule.getResponse(componentInputs.value), isLoadingStoreData], ([response, loading]) => {
    if (loading) {
      storeResponse.data = void 0;
    } else if (response) {
      storeResponse.data = response.data;
      storeResponse.meta = response.meta;
    } else {
      storeResponse.data = null;
      storeResponse.meta = void 0;
    }
  });
  const storeData = computed(() => {
    return storeResponse.data;
  });
  const storeMeta = computed(() => {
    return storeResponse.meta;
  });
  onBeforeUnmount(() => {
    void storeCleanUp(componentInputs.value);
  });
  if (requestDataOnComponentInputsChange) {
    watch(
      componentInputs,
      (_, oldComponentInputs) => {
        void storeCleanUp(oldComponentInputs).then(storeRequestData);
      },
      { deep: true }
    );
  }
  onMounted(() => {
    void storeRequestData();
  });
  return {
    storeErrorsBag,
    isLoadingStoreData,
    hasStoreErrors,
    storeRequestData,
    storeCleanUp,
    storeResponse,
    storeData,
    storeMeta
  };
};

export { useStoreModule };
